module.exports = __webpack_public_path__ + "img/-LV4zRm9sSyLANI3p5rJ.7240e9e3.jpg";